<script>
    import mapPrefs from "../../Stores/mapPreferencesStore.js";
    import dbData from "../../Stores/utilityDBStore.js";
    import { categoriesForCreateGroup, protoItemFromProperties } from "../../scripts/wpn2Edit.js";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let createGroup;
    let selectedCategory = null;
    let selectedInfra = null;
    let categories;
    let nextEnabled;

    $: categories = categoriesForCreateGroup(createGroup);
    $: nextEnabled = selectedCategory != null && selectedInfra != null;

    function proceedToCreate() {
        const props = {entity: selectedCategory.entity, infrastructure: selectedInfra, wpn2_type: selectedCategory.type};
        var createdItem  = protoItemFromProperties(props, $dbData.all, $dbData.user_item);
        dispatch("will-create", {
            createdItem: createdItem
        });
    }
</script>

<section class="cards">
    <div class="card-view create-cat-card">
        <h3 class="card-heading">Pick a Type</h3>
        {#each categories as cat}
            <label class="category-label">
                <input type="radio" bind:group={selectedCategory} value={cat} />
                {cat.title}
            </label>
        {/each}
    </div>
    <div class="card-view create-infra-card">
        <h3 class="card-heading">Pick an infrastructure</h3>
        {#each mapPrefs.allInfrastructures() as infra}
            <label>
                <input
                    type="radio"
                    bind:group={selectedInfra}
                    value={infra.value}
                />
                {infra.title}
            </label>
        {/each}
    </div>
    {#if nextEnabled}
        <div class="next-button-view create-next">
            <button class="create-next-button" on:click={proceedToCreate}>
                Next >>
            </button>
        </div>
    {/if}
</section>

<style>
    .next-button-view {
        position: absolute;
        display: inline-block;
        min-height: 48vh;
        background: white;
        margin: 0.5rem;
        padding: auto;
        width: 20vw;
    }

    .create-infra-card {
        left: 5%;
    }
    .create-cat-card {
        left: calc(50% - 12vw);
    }
    .create-next {
        left: calc(80% - 12vw);
    }
    .create-next-button {
        position: absolute;
        top: 25%;
        left: 0;
        background-color: rgb(67, 148, 11);
        color: white;
        border-radius: 5px;
        cursor: pointer;
        margin: 0.25rem 0.5rem;
        padding: 0.5rem 1rem;
    }
    .create-next-button:disabled {
        color: lightgrey;
        background-color: gray;
    }
</style>
